// modules/Title/TitleInput.js
// 标题场景输入处理模块

import InputHelper from '../InputHelper.js';

export default class TitleInput {
    constructor(scene, menu) {
        this.scene = scene;
        this.menu = menu;
        this.menuInput = null;
    }
    
    /**
     * 设置输入控制
     */
    setupControls() {
        this.menuInput = InputHelper.bindMenuKeyboard(this.scene, {
            blockWhen: () => this.scene.menuActive === false,
            onUp: () => this.menu.moveSelection(-1),
            onDown: () => this.menu.moveSelection(1),
            onSelect: () => {
                const selectedIndex = this.menu.getSelectedMenuItem();
                if (this.scene.handleMenuItemClick) {
                    this.scene.handleMenuItemClick(selectedIndex);
                }
            }
        });
    }

    destroyControls() {
        if (this.menuInput) {
            this.menuInput.destroy();
            this.menuInput = null;
        }
    }
}
